import { SEARCH_RESPELLINGS } from '@/lib/config/search/respellings';
import { SEARCH_SYNONYMS } from '@/lib/config/search/synonyms';

export interface NormalizedQuery {
  original: string;
  corrected: string;
  synonym?: string;
  didCorrect: boolean;
}

/**
 * Normalize a raw search query using known misspellings and synonyms.
 */
export function normalizeSearchQuery(raw: string, force = false): NormalizedQuery {
  const original = raw.trim();
  const lower = original.toLowerCase();

  if (force) {
    return {
      original,
      corrected: original,
      didCorrect: false,
    };
  }

  const corrected = SEARCH_RESPELLINGS[lower] || original;
  const synonym = (SEARCH_SYNONYMS[corrected.toLowerCase()] ) as string;
  const didCorrect = corrected !== original;

  return {
    original,
    corrected,
    synonym,
    didCorrect,
  };
}
